import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { httpRequestTimeoutMetadata } from '../consts/metadata-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const dynamicsAXResourceMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.dynamicsAX.datasetType,
    displayName: stringResources.DynamicsAX_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.dynamicsAX.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-dynamics_AX'
    },
    tableNameDisplay: stringResources.PathLabel,
    tableNamePlural: stringResources.PathsLabel,
    notSupportTypeConversion: true,
    isFirstClass: true,
    isTableNameRequired: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps'],
    copySourceControls: [httpRequestTimeoutMetadata]
};
